<template>
    <b-card
            class="agent-card-hoh"
            :class="{ 'text-center': isMobile}"
    >
        <div class="h-100">
            <b-row>
                <b-col
                        :class="{ 'col-sm-8': !isMobile }"
                >
                    <storage-avatar
                            v-if="isMobile"
                            :user="user"
                            :size="8.75"
                    />

                    <p class="display-name text-truncate">
                        {{ displayName }}
                    </p>
                    <p class="occupation text-truncate">
                        {{ agentOccupation }}
                    </p>
                    <p
                            v-for="(item, index) in phones"
                            :key="index"
                            class="phone text-truncate"
                    >
                        {{ formatStringPhoneUS(item.phone || '') }}
                    </p>
                    <p class="email text-truncate">
                        {{ email }}
                    </p>
                    <b-link
                            v-if="website"
                            class="website text-decoration-none link text-truncate"
                            :href="website.url"
                            target="_blank"
                    >
                        {{ shortWebsite }}
                    </b-link>
                    <template v-if="internalSocialLinks.length">
                        <div
                                class="d-flex social-links-container"
                        >
                            <template
                                    v-for="(socialLink, index) in internalSocialLinks"
                            >
                                <b-button
                                        v-if="socialLink.type !== SOCIAL_LINKS.WEBSITE"
                                        :key="index"
                                        class="border-0 social-link-button text-truncate"
                                        :href="socialLink.url"
                                        target="_blank"
                                        variant="transparent"
                                >
                                    <i
                                            class="social-link-icon"
                                            :class="socialLinkIconMap[socialLink.type]"
                                    />
                                </b-button>
                            </template>
                        </div>
                    </template>

                    <b-img
                            class="org-logo"
                            v-if="companyLogo && isMobile"
                            :src="companyLogo"
                    />
                </b-col>

                <b-col
                        sm="4"
                        v-if="!isMobile"
                >
                    <div class="text-md-right">
                        <storage-avatar
                                :user="user"
                                :size="6.25"
                        />
                        <b-img
                                class="org-logo"
                                v-if="companyLogo"
                                :src="companyLogo"
                        />
                    </div>
                </b-col>
            </b-row>
        </div>
    </b-card>
</template>

<script>
import './AgentCardHoh.scss';
import {
    SOCIAL_LINKS
} from "@milestoneslabs/milestones-core-js/src/AppResources/LandingPageSocialLinkAppResource";
import FileAppResource from "@milestoneslabs/milestones-core-js/src/AppResources/FileAppResource";
import UserAppResource from "@milestoneslabs/milestones-core-js/src/AppResources/UserAppResource";
import StorageAvatar from "../../StorageImage/StorageAvatar";
import IsMobileMixin from "@milestoneslabs/milestones-ui-kit/src/mixins/IsMobileMixin";
import {formatStringPhoneUS} from "../../../helpers/stringHelpers";

export default {
    name: "AgentCardHoh",
    components: {StorageAvatar},
    mixins: [
        IsMobileMixin
    ],
    props: {
        avatar: {
            type: FileAppResource,
            default: () => new FileAppResource({}),
        },
        displayName: {
            type: String,
            default: ''
        },
        occupation: {
            type: Object,
            default: () => {
                return {};
            },
        },
        email: {
            type: String,
            default: ''
        },
        companyLogo: {
            type: String,
            default: ''
        },
        phones: {
            type: Array,
            default: () => []
        },
        socialLinks: {
            type: Array,
            default: () => []
        },
        loanOfficerLicense: {
            type: Object,
            default: () => {
            },
        }
    },
    data() {
        return {
            SOCIAL_LINKS,
            user: new UserAppResource({
                attributes: {
                    fullName: this.displayName,
                },
                relations: {
                    avatarFile: this.avatar && this.avatar.exists ? this.avatar : null,
                }
            }),
        };
    },
    computed: {
        website() {
            return this.socialLinks.find(socialLink => socialLink.type === SOCIAL_LINKS.WEBSITE);
        },
        shortWebsite() {
            if (!this.website) {
                return;
            }

            return this.website.url.replace('http://', '')
                .replace('https://', '');
        },
        socialLinkIconMap() {
            let map = [];

            map[SOCIAL_LINKS.FACEBOOK] = 'fab fa-facebook-f';
            map[SOCIAL_LINKS.YOUTUBE] = 'fab fa-youtube';
            map[SOCIAL_LINKS.INSTAGRAM] = 'fab fa-instagram';
            map[SOCIAL_LINKS.LINKEDIN] = 'fab fa-linkedin-in';
            map[SOCIAL_LINKS.WHATSAPP] = 'fab fa-whatsapp';
            map[SOCIAL_LINKS.SKYPE] = 'fab fa-skype';
            map[SOCIAL_LINKS.LISTING_WEBSITE] = 'fas fa-search-location';

            return map;
        },
        agentOccupation() {
            if (!this.occupation?.name) {
                return '';
            }

            if (!this.loanOfficerLicense?.number) {
                return this.occupation?.name || '';
            }

            return `${this.occupation.name}, NMLS# ${this.loanOfficerLicense.number}`;
        },
        internalSocialLinks() {
            let socialLinks = [];
            this.socialLinks.forEach(item => {
                let order = 0;
                switch (item.type) {
                    case SOCIAL_LINKS.WEBSITE:
                        order = 1;
                        break;
                    case SOCIAL_LINKS.FACEBOOK:
                        order = 2;
                        break;
                    case SOCIAL_LINKS.LINKEDIN:
                        order = 3;
                        break;
                    case SOCIAL_LINKS.YOUTUBE:
                        order = 4;
                        break;
                    case SOCIAL_LINKS.INSTAGRAM:
                        order = 5;
                        break;
                    case SOCIAL_LINKS.WHATSAPP:
                        order = 6;
                        break;
                    case SOCIAL_LINKS.SKYPE:
                        order = 7;
                        break;
                    default:
                        order = 0;
                }
                socialLinks.push({
                    type: item.type,
                    url: item.url,
                    order: order,
                });
            });
            socialLinks.sort((item, compareItem) => {
                return item.order - compareItem.order;
            });
            return socialLinks;
        },
    },
    methods: {
        formatStringPhoneUS,
    },
};
</script>
